/**
 * @generated SignedSource<<a6d075e27154a34efe0a252b47e27a7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type ShortCodeContextProvider_cemeteryFragment$data = {
  readonly items: ReadonlyArray<{
    readonly cemeteryId: number
    readonly name: string
    readonly address: string | null
    readonly accesses: {
      readonly car: string
      readonly other: string
      readonly shuttle_bus: string
      readonly taxi: string
    }
    readonly nearest_station: {
      readonly name: string | null
      readonly distance: number | null
    }
    readonly cemetery_types: ReadonlyArray<{
      readonly name: string
      readonly code: string
    }>
    readonly sects: ReadonlyArray<{
      readonly name: string
      readonly code: string
    }>
    readonly section_types: ReadonlyArray<{
      readonly name: string
      readonly code: string
    }>
    readonly review_summary: {
      readonly total_score: number | null
      readonly count: number
      readonly valuable_review: {
        readonly age: number
        readonly answers: ReadonlyArray<{
          readonly text: string | null
          readonly code: string
        }>
        readonly gender: string
      } | null
    }
    readonly main_image: {
      readonly alt: string | null
      readonly active: boolean
      readonly path: string | null
    } | null
    readonly director_comment: string | null
    readonly descriptions: ReadonlyArray<{
      readonly subject: string | null
    }>
    readonly features: ReadonlyArray<{
      readonly code: string
      readonly name: string
    }>
    readonly facilities: ReadonlyArray<{
      readonly code: string
      readonly name: string
    }>
    readonly kana: string | null
    readonly sub_images: ReadonlyArray<{
      readonly path: string | null
      readonly alt: string | null
    }>
    readonly best_price_by_category: {
      readonly normal: {
        readonly category_code: string
        readonly price1: number | null
        readonly price1_unit: string | null
        readonly price2: number | null
        readonly price2_unit: string | null
        readonly purchase_price: number | null
        readonly purchase_price_unit: string | null
        readonly calculated_purchase_price: number | null
        readonly category_name: string
        readonly purchase_price_option: string
        readonly price3: number | null
        readonly simulated_price3: number | null
        readonly price4: number | null
        readonly price4_name: string | null
        readonly lot_area: number | null
      } | null
      readonly nokotsu: {
        readonly category_code: string
        readonly price1: number | null
        readonly price1_unit: string | null
        readonly price2: number | null
        readonly price2_unit: string | null
        readonly purchase_price: number | null
        readonly purchase_price_unit: string | null
        readonly calculated_purchase_price: number | null
        readonly category_name: string
        readonly purchase_price_option: string
        readonly price3: number | null
        readonly simulated_price3: number | null
        readonly price4: number | null
        readonly price4_name: string | null
        readonly lot_area: number | null
      } | null
      readonly jumoku: {
        readonly category_code: string
        readonly price1: number | null
        readonly price1_unit: string | null
        readonly price2: number | null
        readonly price2_unit: string | null
        readonly purchase_price: number | null
        readonly purchase_price_unit: string | null
        readonly calculated_purchase_price: number | null
        readonly category_name: string
        readonly purchase_price_option: string
        readonly price3: number | null
        readonly simulated_price3: number | null
        readonly price4: number | null
        readonly price4_name: string | null
        readonly lot_area: number | null
      } | null
      readonly eitai_kuyo: {
        readonly category_code: string
        readonly price1: number | null
        readonly price1_unit: string | null
        readonly price2: number | null
        readonly price2_unit: string | null
        readonly purchase_price: number | null
        readonly purchase_price_unit: string | null
        readonly calculated_purchase_price: number | null
        readonly category_name: string
        readonly purchase_price_option: string
        readonly price3: number | null
        readonly simulated_price3: number | null
        readonly price4: number | null
        readonly price4_name: string | null
        readonly lot_area: number | null
      } | null
    }
    readonly prefecture: {
      readonly name: string
    }
    readonly city: {
      readonly name: string
    }
    readonly requestable: boolean
    readonly price_and_specs: ReadonlyArray<{
      readonly priceId: number
      readonly name: string | null
      readonly category_code: string
      readonly price1: number | null
      readonly price1_unit: string | null
      readonly price2: number | null
      readonly price2_unit: string | null
      readonly purchase_price: number | null
      readonly purchase_price_unit: string | null
      readonly calculated_purchase_price: number | null
      readonly price4: number | null
      readonly price4_name: string | null
      readonly price4_unit: string | null
      readonly purchase_price_option: string
      readonly price3: number | null
      readonly price3_unit: string | null
      readonly simulated_price3: number | null
      readonly lot_area: number | null
      readonly lot_area_spec: string | null
      readonly capacity: number | null
      readonly spec: string | null
      readonly image: {
        readonly alt: string | null
        readonly url: string
      } | null
    }>
  }>
  readonly ' $fragmentType': 'ShortCodeContextProvider_cemeteryFragment'
}
export type ShortCodeContextProvider_cemeteryFragment$key = {
  readonly ' $data'?: ShortCodeContextProvider_cemeteryFragment$data
  readonly ' $fragmentSpreads': FragmentRefs<'ShortCodeContextProvider_cemeteryFragment'>
}

const node: ReaderFragment = (function () {
  var v0 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'name',
      storageKey: null
    },
    v1 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'code',
      storageKey: null
    },
    v2 = [v0 /*: any*/, v1 /*: any*/],
    v3 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'alt',
      storageKey: null
    },
    v4 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'path',
      storageKey: null
    },
    v5 = [v1 /*: any*/, v0 /*: any*/],
    v6 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'category_code',
      storageKey: null
    },
    v7 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price1',
      storageKey: null
    },
    v8 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price1_unit',
      storageKey: null
    },
    v9 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price2',
      storageKey: null
    },
    v10 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price2_unit',
      storageKey: null
    },
    v11 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'purchase_price',
      storageKey: null
    },
    v12 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'purchase_price_unit',
      storageKey: null
    },
    v13 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'calculated_purchase_price',
      storageKey: null
    },
    v14 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'purchase_price_option',
      storageKey: null
    },
    v15 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price3',
      storageKey: null
    },
    v16 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'simulated_price3',
      storageKey: null
    },
    v17 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price4',
      storageKey: null
    },
    v18 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'price4_name',
      storageKey: null
    },
    v19 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'lot_area',
      storageKey: null
    },
    v20 = [
      v6 /*: any*/,
      v7 /*: any*/,
      v8 /*: any*/,
      v9 /*: any*/,
      v10 /*: any*/,
      v11 /*: any*/,
      v12 /*: any*/,
      v13 /*: any*/,
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'category_name',
        storageKey: null
      },
      v14 /*: any*/,
      v15 /*: any*/,
      v16 /*: any*/,
      v17 /*: any*/,
      v18 /*: any*/,
      v19 /*: any*/
    ],
    v21 = [v0 /*: any*/]
  return {
    argumentDefinitions: [],
    kind: 'Fragment',
    metadata: null,
    name: 'ShortCodeContextProvider_cemeteryFragment',
    selections: [
      {
        alias: null,
        args: null,
        concreteType: 'Cemetery',
        kind: 'LinkedField',
        name: 'items',
        plural: true,
        selections: [
          {
            alias: 'cemeteryId',
            args: null,
            kind: 'ScalarField',
            name: 'id',
            storageKey: null
          },
          v0 /*: any*/,
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'address',
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryAccesses',
            kind: 'LinkedField',
            name: 'accesses',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'car',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'other',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'shuttle_bus',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'taxi',
                storageKey: null
              }
            ],
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryNearestStation',
            kind: 'LinkedField',
            name: 'nearest_station',
            plural: false,
            selections: [
              v0 /*: any*/,
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'distance',
                storageKey: null
              }
            ],
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryChoice',
            kind: 'LinkedField',
            name: 'cemetery_types',
            plural: true,
            selections: v2 /*: any*/,
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryChoice',
            kind: 'LinkedField',
            name: 'sects',
            plural: true,
            selections: v2 /*: any*/,
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryChoice',
            kind: 'LinkedField',
            name: 'section_types',
            plural: true,
            selections: v2 /*: any*/,
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryReviewSummary',
            kind: 'LinkedField',
            name: 'review_summary',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'total_score',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'count',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                concreteType: 'CemeteryReview',
                kind: 'LinkedField',
                name: 'valuable_review',
                plural: false,
                selections: [
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'age',
                    storageKey: null
                  },
                  {
                    alias: null,
                    args: null,
                    concreteType: 'CemeteryReviewAnswer',
                    kind: 'LinkedField',
                    name: 'answers',
                    plural: true,
                    selections: [
                      {
                        alias: null,
                        args: null,
                        kind: 'ScalarField',
                        name: 'text',
                        storageKey: null
                      },
                      v1 /*: any*/
                    ],
                    storageKey: null
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'gender',
                    storageKey: null
                  }
                ],
                storageKey: null
              }
            ],
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryImage',
            kind: 'LinkedField',
            name: 'main_image',
            plural: false,
            selections: [
              v3 /*: any*/,
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'active',
                storageKey: null
              },
              v4 /*: any*/
            ],
            storageKey: null
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'director_comment',
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryDescription',
            kind: 'LinkedField',
            name: 'descriptions',
            plural: true,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'subject',
                storageKey: null
              }
            ],
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryChoice',
            kind: 'LinkedField',
            name: 'features',
            plural: true,
            selections: v5 /*: any*/,
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryChoice',
            kind: 'LinkedField',
            name: 'facilities',
            plural: true,
            selections: v5 /*: any*/,
            storageKey: null
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'kana',
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryImage',
            kind: 'LinkedField',
            name: 'sub_images',
            plural: true,
            selections: [v4 /*: any*/, v3 /*: any*/],
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryBestPriceByCategory',
            kind: 'LinkedField',
            name: 'best_price_by_category',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                concreteType: 'CemeteryPriceAndSpec',
                kind: 'LinkedField',
                name: 'normal',
                plural: false,
                selections: v20 /*: any*/,
                storageKey: null
              },
              {
                alias: null,
                args: null,
                concreteType: 'CemeteryPriceAndSpec',
                kind: 'LinkedField',
                name: 'nokotsu',
                plural: false,
                selections: v20 /*: any*/,
                storageKey: null
              },
              {
                alias: null,
                args: null,
                concreteType: 'CemeteryPriceAndSpec',
                kind: 'LinkedField',
                name: 'jumoku',
                plural: false,
                selections: v20 /*: any*/,
                storageKey: null
              },
              {
                alias: null,
                args: null,
                concreteType: 'CemeteryPriceAndSpec',
                kind: 'LinkedField',
                name: 'eitai_kuyo',
                plural: false,
                selections: v20 /*: any*/,
                storageKey: null
              }
            ],
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryPrefecture',
            kind: 'LinkedField',
            name: 'prefecture',
            plural: false,
            selections: v21 /*: any*/,
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryCity',
            kind: 'LinkedField',
            name: 'city',
            plural: false,
            selections: v21 /*: any*/,
            storageKey: null
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'requestable',
            storageKey: null
          },
          {
            alias: null,
            args: null,
            concreteType: 'CemeteryPriceAndSpec',
            kind: 'LinkedField',
            name: 'price_and_specs',
            plural: true,
            selections: [
              {
                alias: 'priceId',
                args: null,
                kind: 'ScalarField',
                name: 'id',
                storageKey: null
              },
              v0 /*: any*/,
              v6 /*: any*/,
              v7 /*: any*/,
              v8 /*: any*/,
              v9 /*: any*/,
              v10 /*: any*/,
              v11 /*: any*/,
              v12 /*: any*/,
              v13 /*: any*/,
              v17 /*: any*/,
              v18 /*: any*/,
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'price4_unit',
                storageKey: null
              },
              v14 /*: any*/,
              v15 /*: any*/,
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'price3_unit',
                storageKey: null
              },
              v16 /*: any*/,
              v19 /*: any*/,
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'lot_area_spec',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'capacity',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'spec',
                storageKey: null
              },
              {
                alias: null,
                args: null,
                concreteType: 'CemeteryPriceAndSpecImage',
                kind: 'LinkedField',
                name: 'image',
                plural: false,
                selections: [
                  v3 /*: any*/,
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'url',
                    storageKey: null
                  }
                ],
                storageKey: null
              }
            ],
            storageKey: null
          }
        ],
        storageKey: null
      }
    ],
    type: 'CemeteryResult',
    abstractKey: null
  }
})()

;(node as any).hash = 'b4ea2185b063a763bde58cdb9b722248'

export default node
